import { HttpClient, HttpContext, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class HttpService {
  private readonly httpClient: HttpClient = inject(HttpClient);

  public get<T>(url: string, context?: HttpContext): Observable<T> {
    const fullUrl: string = `${environment.apiUrl}${url}`;
    const request$: Observable<T> = context
      ? this.httpClient.get<T>(fullUrl, { context })
      : this.httpClient.get<T>(fullUrl);

    return request$.pipe(
      catchError((error: HttpErrorResponse): Observable<never> => {
        return throwError((): HttpErrorResponse => error);
      }),
    );
  }

  public post<T>(url: string, data: unknown): Observable<T> {
    return this.httpClient.post<T>(`${environment.apiUrl}${url}`, data).pipe(
      catchError((error: HttpErrorResponse): Observable<never> => {
        return throwError((): HttpErrorResponse => error);
      }),
    );
  }

  public put<T>(url: string, data: unknown): Observable<T> {
    return this.httpClient.put<T>(`${environment.apiUrl}${url}`, data).pipe(
      catchError((error: HttpErrorResponse): Observable<never> => {
        return throwError((): HttpErrorResponse => error);
      }),
    );
  }

  public patch<T>(url: string, data: unknown): Observable<T> {
    return this.httpClient.patch<T>(`${environment.apiUrl}${url}`, data).pipe(
      catchError((error: HttpErrorResponse): Observable<never> => {
        return throwError((): HttpErrorResponse => error);
      }),
    );
  }

  public delete<T>(url: string): Observable<unknown> {
    return this.httpClient.delete<T>(`${environment.apiUrl}${url}`).pipe(
      catchError((error: HttpErrorResponse): Observable<never> => {
        return throwError((): HttpErrorResponse => error);
      }),
    );
  }
}
